import axios from "axios";
const baseUrl = "/api/backend/process";

// This file specifically will be for BPMN process starter
export const process = {
  /**
   * Start BPMN Process
   * @param {Object} params => will be query params
   * @param {Object} payload => will be request body
   * @param {Number} processNumber => number of process
   * @returns
   */
  start: ({ params, payload, processNumber }) =>
    axios.post(`${baseUrl}/${processNumber}`, payload, { params }),
};
